import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";

import AdminLayout from "@/admin/AdminLayout";
import Overview from "@/admin/Overview";
import Agents from "@/admin/Agents";
import AgentDetail from "@/admin/AgentDetail";
import Customers from "@/admin/Customers";
import Products from "@/admin/Products";
import Policy from "@/admin/Policy";
import Deposits from "@/admin/Deposits";
import Orders from "@/admin/Orders";
import Payouts from "@/admin/Payouts";
import Analytics from "@/admin/Analytics";
import Invoice from "@/admin/Invoice";
import Alerts from "@/admin/Alerts";
import CustomerDetail from "@/admin/CustomerDetail";
import Approvals from "@/admin/Approvals";
import FinanceClose from "@/admin/FinanceClose";
import Targets from "@/admin/Targets";
import AuditLog from "@/admin/AuditLog";
import CustomerStatement from "@/pages/CustomerStatement";
import Statement from "@/pages/Statement";
import AgentSimulator from "@/agent/Simulator";
import AgentSubmit from "@/agent/Submit";
import AgentInbox from "@/agent/Inbox";
import Cheques from "@/admin/Cheques";
import FieldSubmissions from "@/admin/FieldSubmissions";

import AgentLayout from "@/agent/AgentLayout";
import AgentHome from "@/agent/Home";
import AgentEarnings from "@/agent/Earnings";
import AgentSales from "@/agent/Sales";
import AgentDeposit from "@/agent/Deposit";
import AgentCustomers from "@/agent/Customers";
import AgentBonuses from "@/agent/Bonuses";
import AgentPlan from "@/agent/Plan";
import AgentProfile from "@/agent/Profile";

function App() {
  return (
    <div className="App">
      <Toaster richColors position="top-center" />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute roles={["admin", "manager"]}>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Overview />} />
              <Route path="agents" element={<Agents />} />
              <Route path="agents/:agentId" element={<AgentDetail />} />
              <Route path="customers" element={<Customers />} />
              <Route path="customers/:id" element={<CustomerDetail />} />
              <Route path="products" element={<Products />} />
              <Route path="policy" element={<Policy />} />
              <Route path="deposits" element={<Deposits />} />
              <Route path="orders" element={<Orders />} />
              <Route path="payouts" element={<Payouts />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="alerts" element={<Alerts />} />
              <Route path="approvals" element={<Approvals />} />
              <Route path="finance" element={<FinanceClose />} />
              <Route path="targets" element={<Targets />} />
              <Route path="audit" element={<AuditLog />} />
              <Route path="cheques" element={<Cheques />} />
              <Route path="field" element={<FieldSubmissions />} />
            </Route>

            <Route
              path="/invoice/:oid"
              element={
                <ProtectedRoute roles={["admin", "manager"]}>
                  <Invoice />
                </ProtectedRoute>
              }
            />

            <Route path="/s/:token" element={<Statement />} />
            <Route path="/i/:token" element={<Invoice />} />
            <Route path="/cs/:token" element={<CustomerStatement />} />
            <Route
              path="/customer-statement/:cid"
              element={
                <ProtectedRoute roles={["admin", "manager"]}>
                  <CustomerStatement />
                </ProtectedRoute>
              }
            />

            <Route
              path="/statement/:agentId"
              element={
                <ProtectedRoute roles={["admin", "manager", "agent"]}>
                  <Statement />
                </ProtectedRoute>
              }
            />

            <Route
              path="/app"
              element={
                <ProtectedRoute roles={["agent"]}>
                  <AgentLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AgentHome />} />
              <Route path="earnings" element={<AgentEarnings />} />
              <Route path="sales" element={<AgentSales />} />
              <Route path="deposit" element={<AgentDeposit />} />
              <Route path="customers" element={<AgentCustomers />} />
              <Route path="bonuses" element={<AgentBonuses />} />
              <Route path="plan" element={<AgentPlan />} />
              <Route path="simulator" element={<AgentSimulator />} />
              <Route path="submit" element={<AgentSubmit />} />
              <Route path="inbox" element={<AgentInbox />} />
              <Route path="profile" element={<AgentProfile />} />
            </Route>

            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
